import { Button, Group } from '@mantine/core';
import { X } from 'lucide-react';
import { type FC, useCallback } from 'react';
import { useShallow } from 'zustand/react/shallow';
import styles from '@/components/flow-drawer/components/flow-drawer-header/flow-drawer-header.module.css';
import { FlowDrawerHeaderMenu } from '@/components/flow-drawer/components/flow-drawer-header-menu';
import useFlow from '@/hooks/use-flow.ts';
import useAppStore, { NotificationOperation } from '@/store/app.ts';
import useFlowStore from '@/store/flow.ts';
import type { TLibraryItemFrontend } from '@/types/common.ts';

type FlowDrawerHeaderActionsProps = {
	originalCard?: TLibraryItemFrontend;
};
export const FlowDrawerHeaderActions: FC<FlowDrawerHeaderActionsProps> = ({
	originalCard
}) => {
	const setNotification = useAppStore((state) => state.setNotification);
	const { flowItem, closeFlowDrawer } = useFlowStore(
		useShallow((state) => ({
			flowItem: state.flowDrawer.flowItem,
			closeFlowDrawer: state.closeFlowDrawer
		}))
	);

	const { deleteCanvasItem } = useFlow();

	const handleRemove = useCallback(() => {
		if (!flowItem) {
			return;
		}
		deleteCanvasItem(flowItem?.type, flowItem?.source.idn);
		closeFlowDrawer();
		setNotification({
			data: flowItem.source,
			operation: flowItem?.source.is_from_library
				? NotificationOperation.REMOVE_FROM_CANVAS
				: NotificationOperation.REMOVE
		});
	}, [deleteCanvasItem, flowItem, closeFlowDrawer, setNotification]);

	return (
		<Group
			justify="flex-end"
			w="fit-content"
			wrap="nowrap"
		>
			{flowItem?.source.idn ? (
				<FlowDrawerHeaderMenu
					handleRemove={handleRemove}
					isFromLibrary={!!flowItem?.source.is_from_library}
					originalCard={originalCard}
				/>
			) : undefined}
			<Button
				onClick={closeFlowDrawer}
				p={0}
				variant="transparent"
			>
				<X className={styles.icon} />
			</Button>
		</Group>
	);
};
